export default __webpack_public_path__ + "static/media/Bracers of Illuminant Conviction.48a73d97.jpg";